export default __webpack_public_path__ + "i18n/translations/translation-ja.3e58b3f7.json";